module.exports = __webpack_public_path__ + "img/bus.082ae1af.png";